import { useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";
import { updateClassroom } from "../api/classroomService";

const EditClassroomComponent = ({ classroom, afterUpdateClassroom }) => {
    const closeRef = useRef();
    const [className, setClassName] = useState("");
    const [isSaving, setIsSaving] = useState(false);

    useEffect(() => {
        setClassName(classroom?.name || "");
    }, [classroom]);

    const updateClassroomHandler = async () => {
        if (!classroom || isSaving) return;

        const name = className.trim();
        if (!name) {
            toast.error("نام کلاس الزامی است.");
            return;
        }

        setIsSaving(true);
        try {
            await updateClassroom(classroom.id, name);
            afterUpdateClassroom({ ...classroom, name });
            closeRef.current?.click();
            toast.success("نام کلاس با موفقیت ویرایش شد.");
        } catch (err) {
            toast.error(
                err.response?.data?.message ||
                "ویرایش نام کلاس با خطا مواجه شد."
            );
        } finally {
            setIsSaving(false);
        }
    };

    return (
        <div
            className="modal fade"
            id="EditClassroomModal"
            tabIndex="-1"
            aria-labelledby="EditClassroomModalLabel"
            aria-hidden="true"
        >
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                    <div className="modal-header">
                        <h1 className="modal-title fs-5" id="EditClassroomModalLabel">
                            ویرایش نام کلاس
                        </h1>
                    </div>
                    <div className="modal-body">
                        <input
                            value={className}
                            onChange={(event) => setClassName(event.target.value)}
                            className="form-control"
                            type="text"
                            placeholder="نام کلاس"
                            aria-label="نام کلاس"
                        />
                    </div>
                    <div className="modal-footer">
                        <button
                            ref={closeRef}
                            type="button"
                            className="btn btn-secondary"
                            data-bs-dismiss="modal"
                        >
                            بستن
                        </button>
                        <button
                            onClick={updateClassroomHandler}
                            type="button"
                            className="btn btn-primary"
                            disabled={isSaving}
                        >
                            {isSaving ? "در حال ذخیره..." : "ذخیره"}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default EditClassroomComponent;
